import { apiInstance } from '../base';
import type { VerifyDto } from './types';

const BASE_URL = '/multichain-pfps';

export const verify = (params: VerifyDto) => {
  return apiInstance.post(`${BASE_URL}/verify`, params);
};
